export default "__VITE_ASSET__BTs0PJjw__"